import React from 'react';
import {
    SimpleShowLayout,
    TextField,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput
} from 'admin-on-rest';
import {sortNumber} from '../shared/tableFunctions';
import List from '../admin/List';
import Show from '../admin/Show';
import Create from '../admin/Create';
import Edit from '../admin/Edit';
import FilterWithSubmit from '../admin/FilterWithSubmit';
import ListTableContainer from '../components/ListTableContainer';
import LocationsWithIdsSelectInput from '../components/LocationsWithIdsSelectInput';
import ValidatedUserTextInput from '../components/ValidatedUserTextInput';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';
import ViewButton from '../buttons/ViewButton';
import EditButton from '../buttons/EditButton';
import TooltipIcon from '../components/TooltipIcon';
import ReactTooltip from 'react-tooltip';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/hardware/tablet-android';
import KitFilter from '../components/KitFilter';

export const fusePosKitIcon = Icon;

/*
 * View: List
 */

const POSKitFilter = (props) => (
    <FilterWithSubmit
        {...props}
        updateOnChange={true}
        displayButton={false}
    >
        <ReferenceInput
            label="Select Kit ID"
            source="filter_kit_id"
            reference="POSKits"
            dependsOn="filter_by"
            perPage={10000}
            allowEmpty
            style={{...viewStyles.filterInline, ...viewStyles.filterHalf}}
        >
            <KitFilter/>
        </ReferenceInput>
        <ReferenceInput
            label="Select Location"
            source="filter_location"
            reference="LocationsForInventory"
            dependsOn="filter_by"
            perPage={10000}
            allowEmpty
            style={{...viewStyles.filterInline, ...viewStyles.filterHalf}}>
            <VirtualizedSelectInput
                addField={true} optionText="filter_name" optionValue="id"
                options={{
                    className: 'full-width',
                    clearable: false,
                    placeholder: 'Select Location'
                }}
            />
        </ReferenceInput>
        <ReferenceInput
            label="Select DBA"
            source="filter_dba"
            reference="DBAs"
            dependsOn="filter_by"
            perPage={10000}
            allowEmpty
            style={{...viewStyles.filterInline, ...viewStyles.filterHalf}}>
            <VirtualizedSelectInput
                addField={true} optionText="name" optionValue="id"
                options={{
                    className: 'full-width',
                    clearable: false,
                    placeholder: 'Select DBA'
                }}
            />
        </ReferenceInput>
        <ReferenceInput
            label="Select District"
            source="filter_district"
            reference="Districts"
            dependsOn="filter_by"
            perPage={10000}
            allowEmpty
            style={{...viewStyles.filterInline, ...viewStyles.filterHalf}}>
            <VirtualizedSelectInput
                addField={true} optionText="name" optionValue="id"
                options={{
                    className: 'full-width',
                    clearable: false,
                    placeholder: 'Select District'
                }}
            />
        </ReferenceInput>
        <SelectInput
            source="filter_by"
            label="Select by:"
            alwaysOn
            choices={[
                {id: 'filter_kit_id', name: 'Kit ID'},
                {id: 'filter_location', name: 'Location'},
                {id: 'filter_dba', name: 'DBA'},
                {id: 'filter_district', name: 'District'}

            ]}
            style={viewStyles.filterInline}
            defaultValue={null}
        />
    </FilterWithSubmit>
);

// Set title for List POS Kits
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>POS Kits</span>;

const ListDescription = () => {
    return (
        <span>
            <p>A <strong>POS Kit</strong> holds your device's information and location it's assigned to.</p>
            <p>Sort by the columns. Click a POS Kit's View icon to view its details, or Edit to modify.
                Click <strong>Create</strong> to add a new POS Kit.</p>
        </span>
    );
};

const ListDescriptionViewOnly = () => {
    return (
        <span>
            <p>A <strong>POS Kit</strong> holds your device's information and location it's assigned to.</p>
            <p>Sort by the columns. Click a POS Kit's View icon to view its details.</p>
        </span>
    );
};

const ListColumns = [
    {source: 'kit_id', label: 'ID', type: 'text'},
    {
        source: 'location_id', label: 'Location', type: 'text',
        hideOnFilter: 'filter_by', hideOnValue: ['filter_location'],
        width: 120,
        sortMethod: (a, b) => sortNumber(a, b, 'ASC')
    },
    {source: 'tablet_model', label: 'Tablet Model', type: 'text'},
    {source: 'device_imei', label: 'Device IMEI', type: 'text'},
    {source: 'sim_imsi', label: 'SIM IMSI', type: 'text'},
    {source: 'cc_reader_sn', label: 'Cayan Device Serial', type: 'text'},
    {source: 'status', label: 'Status', type: 'text'},

    {source: 'id', label: '', style: viewStyles.hidden},

    {source: '', label: '', component: <ViewButton/>, filterable: false, sortable: false, width: 80},
    {source: '', label: '', component: <EditButton/>, filterable: false, sortable: false, width: 80}
];

const ListColumnsViewOnly = [
    {source: 'kit_id', label: 'ID', type: 'text'},
    {
        source: 'location_id', label: 'Location', type: 'text',
        hideOnFilter: 'filter_by', hideOnValue: ['filter_location'],
        width: 120,
        sortMethod: (a, b) => sortNumber(a, b, 'ASC')
    },
    {source: 'tablet_model', label: 'Tablet Model', type: 'text'},
    {source: 'device_imei', label: 'Device IMEI', type: 'text'},
    {source: 'sim_imsi', label: 'SIM IMSI', type: 'text'},
    {source: 'cc_reader_sn', label: 'Cayan Device Serial', type: 'text'},
    {source: 'status', label: 'Status', type: 'text'},

    {source: 'id', label: '', style: viewStyles.hidden},

    {source: '', label: '', component: <ViewButton/>, filterable: false, sortable: false, width: 80}
];

export const fusePosKitList = (props) => (
    <List
        title={ListTitle}
        listType="table"
        desc={<ListDescription/>}
        filters={<POSKitFilter/>}
        requiresFilter={true}
        allowQueryString={false}
        pagination={null}
        {...props}
    >
        <ListTableContainer
            {...props}
            columns={ListColumns}
            perPage={20}
            currentSort={{field: 'kit_id', order: 'ASC'}}
        />
    </List>

);

export const fusePosKitListViewOnly = (props) => (
    <List
        title={ListTitle}
        listType="table"
        desc={<ListDescriptionViewOnly/>}
        filters={<POSKitFilter/>}
        requiresFilter={true}
        allowQueryString={false}
        pagination={null}
        {...props}
    >
        <ListTableContainer
            {...props}
            columns={ListColumnsViewOnly}
            perPage={20}
            currentSort={{field: 'kit_id', order: 'ASC'}}
        />
    </List>

);

/*
 * View: Show
 */

// Set title for Show POS Kit
const ShowTitle = ({record}) => {
    return <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                         className="avatar-title"/>{record ? `${record.id}` : 'POS Kit'}</span>;
};

const ShowDescription = () => {
    return (
        <span>
            <p>Review POS Kit details below. To edit this POS Kit, click <strong>Edit</strong> above.</p>
        </span>
    );
};

/*
 * Show POS Kit Table
 */
export const fusePosKitShow = (props) => (
    <Show {...props} title={<ShowTitle/>} desc={<ShowDescription/>}>
        <SimpleShowLayout>
            <TextField source="kit_id" label="Kit ID" style={viewStyles.rowShowField}/>
            <TextField source="location_id" label="Location" style={viewStyles.rowShowField}/>
            <hr style={viewStyles.break}/>
            <TextField source="tablet_model" label="Tablet Model"/>
            <TextField source="device_imei" label="Device IMEI"/>
            <TextField source="sim_imsi" label="SIM IMSI"/>
            <TextField source="cc_reader_sn" label="Cayan Device Serial"/>
            <hr style={viewStyles.break}/>
            <TextField source="status" label="Status"/>
        </SimpleShowLayout>
    </Show>
);

/*
 * View: Create form
 */

// Set title for Create POS Kit
const CreateTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                                  className="avatar-title"/>Create a POS Kit</span>;

const CreateDescription = () => {
    return (
        <span>
            <p>Create a POS Kit by completing the form below.</p>
        </span>
    );
};

// Set defaults for Create form
const defaultCreateValues = {
    location_id: '',
    tablet_model: '',
    device_imei: '',
    sim_imsi: '',
    cc_reader_sn: ''
};

/*
 * Create POS Kit form
 */
export const fusePosKitCreate = (props) => (
    <Create {...props} title={CreateTitle} desc={<CreateDescription/>}>
        <SimpleForm defaultValue={defaultCreateValues} redirect="list">
            <ValidatedUserTextInput
                source="kit_id"
                fieldType="text"
                label="Kit ID*"
                buttonLabel="Check Availability"
                successMessage="This Kit ID is available."
                errorDuplicateMessage="A Kit with this ID already exists."
                errorValidateMessage="Need to validate Kit ID."
                errorRequiredMessage="A unique Kit ID number is required."
                fieldResource="POSKitsByKitId"
                isRequired={true}
            />
            <span style={viewStyles.fieldDescription}>
                Enter a unique value for identifying this POS Kit (ex: K-001234).
                <TooltipIcon dataFor="ttId"/>
                <ReactTooltip id="ttId" type="light" effect="solid" multiline={true} border={true} className="tooltip">
                    A <strong>Kit ID</strong> must be unique.
                </ReactTooltip>
            </span>

            <LocationsWithIdsSelectInput
                {...props}
                source="location_id"
                optionValue="id"
                label="Select a Location*"
                isRequired={true}
                allowEmpty
                formName="record-form"
            />

            <TextInput source="tablet_model" label="Tablet Model" style={viewStyles.rowField}/>
            <TextInput source="device_imei" label="Device IMEI" style={viewStyles.rowField}/>
            <TextInput source="sim_imsi" label="SIM IMSI" style={viewStyles.rowField}/>
            <TextInput source="cc_reader_sn" label="Cayan Device Serial" style={viewStyles.rowField}/>
            <TextInput source="status" label="Status" style={viewStyles.rowField}/>

            <span style={viewStyles.fieldInstructions}>
                After clicking <strong>Save</strong>, you will be redirected to the POS Kits List.
            </span>
            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>
        </SimpleForm>
    </Create>
);

/*
 * View: Edit form
 */

// Set title for Edit POS Kit
const EditTitle = ({record}) => {
    return <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                         className="avatar-title"/>Edit {record ? `${record.kit_id}` : 'POS Kit'}</span>;
};

const EditDescription = () => {
    return (
        <span>
            <p>Modify fields in the tabs below. Click <strong>Save</strong> to store this POS Kit's details.</p>
        </span>
    );
};

/*
 * Edit POS Kit form
 */
export const fusePosKitEdit = (props) => (
    <Edit {...props} title={<EditTitle/>} desc={<EditDescription/>}>
        <SimpleForm>
            <TextField source="id" label="Kit ID"/>

            <LocationsWithIdsSelectInput
                {...props}
                source="location_id"
                optionValue="id"
                label="Select a Location*"
                isRequired={true}
                allowEmpty
            />

            <TextInput source="tablet_model" label="Tablet Model" style={viewStyles.rowField}/>
            <TextInput source="device_imei" label="Device IMEI" style={viewStyles.rowField}/>
            <TextInput source="sim_imsi" label="SIM IMSI" style={viewStyles.rowField}/>
            <TextInput source="cc_reader_sn" label="Cayan Device Serial" style={viewStyles.rowField}/>
            <TextInput source="status" label="Status" style={viewStyles.rowField}/>


            <span style={viewStyles.fieldInstructions}>
                After clicking <strong>Save</strong>, you will be redirected to the POS Kits List.
            </span>
            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/Fuse/Kit/posKit.js